import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { DemographicGender } from '@/core/api/entities/demographicGender'
import { DemographicGenderMapper } from '@/core/api/mappers/demographicGenderMapper'
import demographicGenderService from '@/core/api/services/demographicGenderService'

export const useDemographicGenders = ({
	config,
	options,
}: any = {}): UseQueryResult<DemographicGender[], Error> => {
	const QUERY_KEY = [
		'demographic_genders',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			demographicGenderService
				.getDemographicGenders(config)
				.then(({ data }) => {
					return DemographicGenderMapper.toEntities(data.data)
				}),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
